import { render, staticRenderFns } from "./QualityofSubProducts.vue?vue&type=template&id=18c360c2&scoped=true&"
import script from "./QualityofSubProducts.vue?vue&type=script&lang=js&"
export * from "./QualityofSubProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c360c2",
  null
  
)

export default component.exports